/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".review-item-container[_ngcontent-%COMP%]{position:relative;padding:5px 15px;margin:5px}.review-item-container[_ngcontent-%COMP%]   .helpful-container[_ngcontent-%COMP%]{position:absolute;right:0;margin:5px 15px}.review-item-container[_ngcontent-%COMP%]   .helpful-container[_ngcontent-%COMP%]   .helpful-button[_ngcontent-%COMP%]{padding:0 2px}.review-item-container[_ngcontent-%COMP%]   .user-type[_ngcontent-%COMP%]{font-weight:100}[_nghost-%COMP%]     .ant-comment-content-author-name{font-weight:500;font-size:14px}"];
export { styles as styles };
